

<div class="seperator"></div>
<div class="title" mat-dialog-title>Select BaseAccount</div>
<div class="dialog-body">
    <div class="body-content">
        <div class="form-text">You can select multiple base accounts from the below</div>
        <mat-form-field appearance="outline" class="form-field">
            <mat-label>Yahoo! Japan Ads Base Accounts</mat-label>
                <mat-select multiple [formControl]="selectedBaseAccountIds">
                    <mat-option *ngFor="let baseAccount of baseAccounts" [value]="baseAccount.accountId">
                        {{baseAccount.accountName}}
                    </mat-option>
                </mat-select>
        </mat-form-field>
    </div>
</div>
<div class="dialog-footer">
    <div>
        <button mat-raised-button class="rubii-btn add-btn" color="primary" (click)="connect()">
            Connect Data Source
        </button>
    </div>
</div>